export interface IAppDynamicsConfig {
  appDynamicsKey: string;
  appDynamicsScriptURL: string;
}

export class AppDynamicsSettingsService {
  appDynamicsKey: string;
  appDynamicsScriptURL: string;
  constructor() {}

  loadConfig(config): void {
    this.appDynamicsKey = config.appDynamicsKey;
    this.appDynamicsScriptURL = config.appDynamicsScriptURL;
  }
}
